<template>
  <el-dialog
    title="确认付款银行信息"
    :visible.sync="showPassMultipleDialog"
    width="90%"
    top="5%"
  >
    <el-form
      ref="formRef"
      :model="settlementForm"
      :rules="formRules"
      class="pass-multiple-form"
    >
      <el-row :gutter="24">
        <el-col :span="6" v-if="settlementForm.newServiceTenantName">
          <el-form-item
            class="inline-form-item"
            label="原付款方:"
            required
            :show-message="false"
          >
            <span>{{ settlementForm.oldServiceTenantName }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="6" v-if="settlementForm.newServiceTenantName">
          <el-form-item
            class="inline-form-item"
            label="新付款方:"
            required
            :show-message="false"
          >
            <span>{{ settlementForm.newServiceTenantName }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="6" v-if="!settlementForm.newServiceTenantName">
          <el-form-item
            class="inline-form-item"
            label="付款方:"
            required
            :show-message="false"
          >
            <span>{{ settlementForm.serviceTenantName }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            class="inline-form-item"
            label="合计应付金额（元）:"
            required
            :show-message="false"
          >
            <span style="color: #ff5f1f">{{ settlementForm.payAmount }}</span>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item
        prop="settleDetail"
        class="settle-detail-form-item"
        :show-message="false"
      >
        <div
          v-for="(item, index) in settlementForm.settleDetail"
          :key="index"
          class="mb15 pl10"
        >
          <!-- <el-row :gutter="24">
          <el-col :span="18">
            <div style="font-weight: 600; font-size: 14px;">付款银行 {{ index + 1 }}</div>
          </el-col>
        </el-row> -->

          <!-- <el-row :gutter="24" style="margin-bottom: 10px">
          <el-col :span="6">
            <div style="display: flex; align-items: center;">
              <span style="color: red">*</span>
              <span style="margin-right: 10px">任务大类：</span>
              <span>{{ item.taskType || "-" }}</span>
            </div>
          </el-col>
          <el-col :span="6">
            <div style="display: flex; align-items: center;">
              <span style="color: red">*</span>
              <span style="margin-right: 10px">开票金额(元)：</span>
              <span>{{ item.totalAmount || "-" }}</span>
            </div>
          </el-col>
        </el-row> -->

          <el-row
            :gutter="24"
            style="display: flex; align-items: center; height: 40px"
          >
            <el-col :span="6">
              <el-form-item
                class="inline-form-item"
                label="付款开户银行："
                :prop="'settleDetail.' + index + '.payBankName'"
                :rules="detailFieldRules.payBankName"
                :show-message="false"
              >
                <el-select
                  style="width: 200px"
                  v-model="item.payBankName"
                  placeholder="请选择"
                  @change="(value) => onChangePayBankName(value, index)"
                >
                  <el-option
                    v-for="item in payBankList"
                    :key="item.guid"
                    :label="item.bankName"
                    :value="item.bankName"
                  >
                    <span style="float: left">{{
                      `${item.bankName}_${item.bankAccount}_${$getNameByKey(
                        item.accountType,
                        "账户类型"
                      )}`
                    }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                class="inline-form-item"
                label="付款银行账户："
                :prop="'settleDetail.' + index + '.payBankAccount'"
                :rules="detailFieldRules.payBankAccount"
                :show-message="false"
              >
                <span>{{ item.payBankAccount || "-" }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item
                class="inline-form-item"
                label="付款金额(元)："
                :prop="'settleDetail.' + index + '.payAmount'"
                :rules="detailFieldRules.payAmount"
                :show-message="false"
              >
                <AmountInput
                  width="150px"
                  v-model="item.payAmount"
                  placeholder="请填写"
                  @input="() => onPayAmountChange(index)"
                />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item
                class="inline-form-item"
                label="付款日期："
                :prop="'settleDetail.' + index + '.settleDate'"
                :rules="detailFieldRules.settleDate"
                :show-message="false"
              >
                <el-date-picker
                  style="width: 150px"
                  v-model="item.settleDate"
                  type="date"
                  placeholder="选择日期"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                />
              </el-form-item>
            </el-col>
            <el-col :span="2" style="display: flex">
              <div
                class="fontC-red"
                style="margin-right: 10px"
                v-if="settlementForm.settleDetail.length > 1"
                @click="removeBankItem(index)"
              >
                删除
              </div>
              <div
                class="fontC-4fa1a4"
                @click="addBankItem"
                v-if="index == settlementForm.settleDetail.length - 1"
              >
                添加
              </div>
            </el-col>
          </el-row>
        </div>
      </el-form-item>

      <!-- <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item prop="approveSuggest" label-width="100px">
            <span slot="label"> 通过备注： </span>
            <el-input
              style="margin: 10px 0"
              type="textarea"
              :rows="5"
              placeholder="请填写通过备注（选填）"
              v-model="formData.approveSuggest"
              maxlength="100"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row> -->
    </el-form>
    <div slot="footer" class="dialog-footer">
      <!-- <el-button @click="showPassMultipleDialog = false">取消</el-button> -->
      <el-button type="info" class="w240" @click="submitForm"
        >审批通过</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import Decimal from "decimal.js";
import { submitApproveFirst } from "@/api/msSalesPerformService";
import { getTenantDetail } from "@/api/msCustomerService";
import AmountInput from "@/components/AmountInput/index.vue";
export default {
  name: "passMultipleDialog",
  components: {
    AmountInput,
  },
  props: {
    onChangeFullscreenLoading: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      settlementForm: {
        serviceTenantName: "",
        oldServiceTenantName: "",
        oldServicerGuid: "",
        newServiceTenantName: "",
        newServicerGuid: "",
        payAmount: "",
        settleDetail: [],
        approveSuggest: "",
      },
      /** 付款明细字段校验规则 */
      detailFieldRules: {
        payBankName: [
          { required: true, message: "请选择付款开户银行", trigger: "change" },
        ],
        payBankAccount: [
          { required: true, message: "请填写付款银行账户", trigger: "change" },
        ],
        payAmount: [
          { required: true, message: "请填写付款金额", trigger: "change" },
          {
            validator: (rule, value, callback) => {
              if (value && parseFloat(value) <= 0) {
                callback(new Error("付款金额必须大于0"));
                return;
              }
              callback();
            },
            trigger: "change",
          },
        ],
        settleDate: [
          { required: true, message: "请选择付款日期", trigger: "change" },
        ],
      },
      /** 表单校验规则（付款金额合计） */
      formRules: {
        settleDetail: {
          type: "array",
          required: true,
          validator: (rule, value, callback) => {
            if (!value || value.length === 0) {
              callback(new Error("请添加付款银行信息"));
              return;
            }
            const totalPayAmount = value.reduce((sum, item) => {
              return sum.plus(new Decimal(item.payAmount || 0));
            }, new Decimal(0));
            const expectedAmount = new Decimal(
              (this.settlementForm.payAmount || "0")
                .toString()
                .replace(/,/g, "")
            );
            if (!totalPayAmount.equals(expectedAmount)) {
              callback(
                new Error(
                  `付款金额总和必须等于合计应付金额 ${expectedAmount.toFixed(
                    2
                  )} 元`
                )
              );
              return;
            }
            callback();
          },
          trigger: "change",
        },
      },
      showPassMultipleDialog: false,
      serviceTenantGuid: "",
      payBankList: [],
    };
  },
  methods: {
    /**
     * 打开审批通过对话框
     */
    async open(data) {
      this.serviceTenantGuid = data.serviceTenantGuid;
      this.settlementForm = data;
      // 如果银行列表为空，则获取银行信息
      if (this.payBankList.length == 0) {
        await this.getBankList();
      }
      // 默认只保留一条结算明细
      if (
        this.settlementForm.settleDetail &&
        this.settlementForm.settleDetail.length > 0
      ) {
        this.settlementForm.settleDetail = [
          this.settlementForm.settleDetail[0],
        ];
      }
      this.showPassMultipleDialog = true;
    },

    /**
     * 添加付款银行项
     */
    addBankItem() {
      const firstItem = this.settlementForm.settleDetail[0];
      const newItem = {
        taskTypeGuid: firstItem.taskTypeGuid,
        taskType: firstItem.taskType,
        totalAmount: firstItem.totalAmount,
        payBankName: "",
        payBankAccount: "",
        payAmount: "",
        settleDate: "",
      };
      this.settlementForm.settleDetail.push(newItem);
    },

    /**
     * 删除指定索引的付款银行项
     */
    removeBankItem(index) {
      this.settlementForm.settleDetail.splice(index, 1);
    },

    /**
     * 付款金额变化后触发合计校验
     */
    onPayAmountChange(index) {
      // const maxValue = item.totalAmount;
      // if (newValue > maxValue) {
      //   newValue = maxValue;
      //   this.$message.error("付款金额不能大于开票金额");
      // }
      this.$nextTick(() => {
        this.$refs.formRef?.validateField("settleDetail");
        this.$refs.formRef?.validateField(`settleDetail.${index}.payAmount`);
      });
    },

    /**
     * 处理付款银行选择变化
     * 根据选择的银行名称自动填充银行账户信息
     */
    onChangePayBankName(value, index) {
      const payBank = this.payBankList.find((item) => item.bankName === value);
      if (payBank) {
        this.settlementForm.settleDetail[index].payBankAccount =
          payBank.bankAccount;
        this.settlementForm.settleDetail[index].payBankName = value;
        this.settlementForm.settleDetail = [
          ...this.settlementForm.settleDetail,
        ];
        this.$nextTick(() => {
          this.$refs.formRef?.validateField(
            `settleDetail.${index}.payBankAccount`
          );
        });
      }
    },
    /**
     * 获取付款银行列表
     */
    async getBankList() {
      const guid =
        this.settlementForm.newServicerGuid ||
        this.settlementForm.oldServicerGuid;
      const { data } = await getTenantDetail(guid);
      if (data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
        this.payBankList = data.data.bankList;
      } else {
        this.$message.error(data.msg);
      }
    },

    /**
     * 表单校验
     * 校验失败时使用 message 提示
     */
    validateForm() {
      return new Promise((resolve, reject) => {
        this.$refs.formRef.validate((valid, errors) => {
          if (valid) {
            resolve(true);
          } else {
            // 获取第一个错误信息并使用 message 提示
            const firstError = Object.values(errors)[0][0].message;
            this.$message.error(firstError);
            reject(new Error("表单校验失败"));
          }
        });
      });
    },

    /**
     * 提交审批通过表单
     * 先校验表单，再调用后端接口提交审批
     */
    async submitForm() {
      // 使用表单校验
      await this.validateForm();
      this.onChangeFullscreenLoading(true);
      const submitApproveFirstFormData = {
        approveSuggest: this.settlementForm.approveSuggest,
        guid: this.settlementForm.guid,
        approveStaffGuid: this.settlementForm.approveStaffGuid,
        approveGuid: this.settlementForm.approveGuid,
        payBankInfoList: this.settlementForm.settleDetail.map((item) => {
          return {
            taskTypeGuid: item.taskTypeGuid,
            payAmount: Number(item.payAmount).toFixed(2),
            payBankName: item.payBankName,
            payBankAccount: item.payBankAccount,
            taskType: item.taskType,
            totalAmount: item.totalAmount,
            settleDate: item.settleDate,
          };
        }),
      };
      const { data } = await submitApproveFirst(submitApproveFirstFormData);
      if (data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.success("审批通过！");
        this.showPassMultipleDialog = false;
        this.$router.go(-1);
      } else {
        this.$message.error(data.msg);
      }
      this.onChangeFullscreenLoading(false);
    },
  },
};
</script>

<style scoped lang="less">
.pass-multiple-form {
  /deep/.inline-form-item {
    display: flex;
    align-items: center;
    margin-bottom: 0;
    height: 40px;
    width: 100%;

    &::before,
    &::after {
      display: none;
    }

    .el-form-item__label {
      float: none;
      width: auto !important;
      line-height: 40px;
      padding: 0;
      white-space: nowrap;
      padding-right: 8px;
    }

    .el-form-item__content {
      flex: none;
    }
  }
}

.settle-detail-form-item {
  margin-bottom: 0;
}

.form-title-item {
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  margin-left: 16px;
  font-weight: 600;
}
/* 对话框底部按钮样式 */
.dialog-footer {
  display: flex;
  justify-content: center;
}
</style>
